import React, { Fragment, useEffect, useState } from 'react'
import axios from 'axios'
import Message from '../Components/Message/Message.jsx'
import styles from './challan-detailed.module.css'
import Loading from '../Components/Loading/Loading'

export default function OrderHistory(props) {
    const accessToken = sessionStorage.getItem('accessToken')
    const [showDetails, setShowDetails] = useState(false)
    const [message, setMessage] = useState('')
    const [messageClass, setMessageClass] = useState('')
    const [loading, setLoading] = useState(true)
    const [selectedRecord, setSelectedRecord] = useState('')
    const [result, setResult] = useState([])
    const [totalRecord, setTotalRecord] = useState()
    const [pageNumber, setPageNumber] = useState(1)
    const apiDomain = document.location.origin === 'https://dashboard.invincibleocean.com' ? 'https://api.invincibleocean.com' : 'https://api.dev.invincibleocean.com'

    const isDevelopment = process.env.REACT_APP_ENVIRONMENT === 'development'
    const endpoint = isDevelopment ? 'invincible/vehicle-echallan-paidList-dev-V2' : 'invincible/vehicle-echallan-paidList-V2'

    const fetchFunction = (number) => {
        axios
            .get(`${apiDomain}/${endpoint}?accessToken=${accessToken}&pageNo=${number ? number : pageNumber}`)
            .then((res) => {
                setLoading(false)
                setTimeout(() => setMessage(''), 5000)
                if (res.data.code === 200) {
                    setResult(res?.data?.result)
                    setTotalRecord(res.data.totalRecords)
                    setPageNumber(parseInt(res.data.pageNumber))
                } else {
                    setMessageClass('error')
                }
            })
            .catch((error) => {
                setLoading(false)
                console.error(error)
                setMessageClass('error')
                setMessage(error?.response?.data?.message || 'Something went wrong. try again later')
                setTimeout(() => setMessage(''), 5000)
            })
    }

    useEffect(() => {
        fetchFunction()
    }, [])

    function calculateTotalWithGST(amount, convenienceFee) {
        const gst = convenienceFee * 0.18
        const total = amount + convenienceFee + gst
        return total
    }

    return (
        <Fragment>
            {message && <Message message={message} messageClass={messageClass} closeMessage={() => setMessage('')} />}
            {loading ? (
                <Loading />
            ) : (
                <div className={styles.orderHistoryWrapper}>
                    <div className={`${styles['action-buttons']} px-md-5`}>
                        <span className={styles['back-btn']} onClick={() => props.closeHistory()}>
                            <img src="./images/challan-detailed/backArrow.svg" alt="edit" /> Back
                        </span>
                    </div>

                    <div className="row px-md-5">
                        {result.length === 0 ? (
                            <div className="col-12 d-flex justify-content-center align-items-center" style={{ minHeight: '50vh' }}>
                                <div className="text-center">
                                    <img src="./images/no-records.svg" alt="No orders" style={{ width: '120px' }} />
                                    <h4 className="text-muted mt-4">No orders history found</h4>
                                </div>
                            </div>
                        ) : (
                            result.map((data, index) => (
                                <div key={index} className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4">
                                    {data?.challanNumber?.map((item, i) => (
                                        <div className={styles.orderCard} key={i}>
                                            <div className={styles.orderCardHeader}>
                                                <div>
                                                    <div className={styles.orderCardLabel}>Total amount paid</div>
                                                    <div className={styles.orderCardAmount}>
                                                        ₹{calculateTotalWithGST(data?.challanDetail[item].amountChallan, data?.challanDetail[item].convenience_fee)}
                                                    </div>
                                                </div>
                                                <span className={styles.orderCardStatus}>{data?.challanDetail[item].status}</span>
                                            </div>
                                            <div className={styles.orderCardBody}>
                                                <div className={styles.orderCardViolatorLabel}>Violator Name</div>
                                                <div className={styles.orderCardViolator}>{data?.challanDetail[item].nameOwner}</div>
                                                <div className={styles.orderCardChallanRow}>
                                                    <span className={styles.orderCardChallanNo}># {data?.challanDetail[item].challanNo}</span>
                                                    <span className={styles.orderCardChallanType}>{data?.challanDetail[item].court_status_desc}</span>
                                                </div>
                                            </div>
                                            <button
                                                className={styles.orderCardBtn}
                                                onClick={() => {
                                                    setSelectedRecord(data?.challanDetail[item])
                                                    setShowDetails(true)
                                                }}
                                            >
                                                View details
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            ))
                        )}
                    </div>

                    {Math.ceil(totalRecord / 25) > 1 && (
                        <div className="pagination">
                            {pageNumber <= 1 ? (
                                <span className="fa fa-angle-left pagination-arrow-disabled"></span>
                            ) : (
                                <span className="fa fa-angle-left pagination-arrow" onClick={() => fetchFunction(pageNumber - 1)}></span>
                            )}
                            <span>
                                {pageNumber} of {Math.ceil(totalRecord / 25)} pages
                            </span>
                            {pageNumber === Math.ceil(totalRecord / 25) ? (
                                <span className="fa fa-angle-right pagination-arrow-disabled"></span>
                            ) : (
                                <span className="fa fa-angle-right pagination-arrow" onClick={() => fetchFunction(pageNumber + 1)}></span>
                            )}
                        </div>
                    )}

                    {/* Order Details Modal */}
                    {showDetails && (
                        <div className={styles.orderDetailsModalOverlay}>
                            <div className={styles.orderDetailsModal}>
                                <div className={styles.orderDetailsHeader}>
                                    <span>Order details</span>
                                    <span className={styles.orderDetailsClose} onClick={() => setShowDetails(false)}>
                                        &#10005;
                                    </span>
                                </div>
                                <div className={styles.orderDetailsCard}>
                                    <div className={styles.orderDetailsTopRow}>
                                        <div>
                                            <div className={styles.orderCardViolatorLabel}>Violator Name</div>
                                            <div className={styles.orderCardViolator}>{selectedRecord.nameOwner}</div>
                                            <div className={styles.orderCardChallanNo}># {selectedRecord.challanNo}</div>
                                        </div>
                                        <div className={styles.orderDetailsAmountBlock}>
                                            <div className={styles.orderCardLabel}>Total amount paid</div>
                                            <div className={styles.orderCardAmount}>₹{calculateTotalWithGST(selectedRecord.amountChallan, selectedRecord.convenience_fee)}</div>
                                        </div>
                                    </div>
                                    {/* Stepper */}
                                    <div className={styles.orderStepper}>
                                        <div className={styles.orderStepActive}>
                                            <span className={styles.orderStepCircleActive}></span>
                                            <span>Amount Paid</span>
                                        </div>
                                        <div className={styles.orderStepLine}></div>
                                        <div className={styles.orderStepCurrent}>
                                            <span className={styles.orderStepCircleCurrent}></span>
                                            <span>Processing</span>
                                            {/* <div className={styles.orderStepSubtext}>We are currently in virtual court</div> */}
                                        </div>
                                        <div className={styles.orderStepLine}></div>
                                        <div className={styles.orderStepDisabled}>
                                            <span className={styles.orderStepCircleDisabled}></span>
                                            <span>Settled successfully</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            )}
        </Fragment>
    )
}
